function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("jqhiM", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $e23dddd515a6919f$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $e23dddd515a6919f$var$extendStatics = function extendStatics1(d, b) {
    $e23dddd515a6919f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e23dddd515a6919f$var$extendStatics(d, b);
};
function $e23dddd515a6919f$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e23dddd515a6919f$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e23dddd515a6919f$export$18ce0697a983be9b = function __assign1() {
    $e23dddd515a6919f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e23dddd515a6919f$export$18ce0697a983be9b.apply(this, arguments);
};
function $e23dddd515a6919f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e23dddd515a6919f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e23dddd515a6919f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e23dddd515a6919f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e23dddd515a6919f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e23dddd515a6919f$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $aLLdK._)(x)) === "symbol" ? x : "".concat(x);
}
function $e23dddd515a6919f$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $aLLdK._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e23dddd515a6919f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e23dddd515a6919f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e23dddd515a6919f$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $e23dddd515a6919f$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e23dddd515a6919f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e23dddd515a6919f$export$45d3717a4c69092e(o, m, p);
}
function $e23dddd515a6919f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e23dddd515a6919f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e23dddd515a6919f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e23dddd515a6919f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e23dddd515a6919f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e23dddd515a6919f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e23dddd515a6919f$export$10c90e4f7922046c(v) {
    return this instanceof $e23dddd515a6919f$export$10c90e4f7922046c ? (this.v = v, this) : new $e23dddd515a6919f$export$10c90e4f7922046c(v);
}
function $e23dddd515a6919f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $e23dddd515a6919f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $e23dddd515a6919f$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e23dddd515a6919f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $e23dddd515a6919f$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e23dddd515a6919f$export$19a8beecd37a4c45 === "function" ? $e23dddd515a6919f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $e23dddd515a6919f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e23dddd515a6919f$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e23dddd515a6919f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e23dddd515a6919f$export$45d3717a4c69092e(result, mod, k);
    }
    $e23dddd515a6919f$var$__setModuleDefault(result, mod);
    return result;
}
function $e23dddd515a6919f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e23dddd515a6919f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e23dddd515a6919f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e23dddd515a6919f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e23dddd515a6919f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e23dddd515a6919f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e23dddd515a6919f$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $e23dddd515a6919f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e23dddd515a6919f$export$2e2bcd8739ae039 = {
    __extends: $e23dddd515a6919f$export$a8ba968b8961cb8a,
    __assign: $e23dddd515a6919f$export$18ce0697a983be9b,
    __rest: $e23dddd515a6919f$export$3c9a16f847548506,
    __decorate: $e23dddd515a6919f$export$29e00dfd3077644b,
    __param: $e23dddd515a6919f$export$d5ad3fd78186038f,
    __metadata: $e23dddd515a6919f$export$f1db080c865becb9,
    __awaiter: $e23dddd515a6919f$export$1050f835b63b671e,
    __generator: $e23dddd515a6919f$export$67ebef60e6f28a6,
    __createBinding: $e23dddd515a6919f$export$45d3717a4c69092e,
    __exportStar: $e23dddd515a6919f$export$f33643c0debef087,
    __values: $e23dddd515a6919f$export$19a8beecd37a4c45,
    __read: $e23dddd515a6919f$export$8d051b38c9118094,
    __spread: $e23dddd515a6919f$export$afc72e2116322959,
    __spreadArrays: $e23dddd515a6919f$export$6388937ca91ccae8,
    __spreadArray: $e23dddd515a6919f$export$1216008129fb82ed,
    __await: $e23dddd515a6919f$export$10c90e4f7922046c,
    __asyncGenerator: $e23dddd515a6919f$export$e427f37a30a4de9b,
    __asyncDelegator: $e23dddd515a6919f$export$bbd80228419bb833,
    __asyncValues: $e23dddd515a6919f$export$e3b29a3d6162315f,
    __makeTemplateObject: $e23dddd515a6919f$export$4fb47efe1390b86f,
    __importStar: $e23dddd515a6919f$export$c21735bcef00d192,
    __importDefault: $e23dddd515a6919f$export$da59b14a69baef04,
    __classPrivateFieldGet: $e23dddd515a6919f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e23dddd515a6919f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e23dddd515a6919f$export$81fdc39f203e4e04,
    __addDisposableResource: $e23dddd515a6919f$export$88ac25d8e944e405,
    __disposeResources: $e23dddd515a6919f$export$8f076105dc360e92
};

});

parcelRequire.register("aLLdK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $128ca221f03a6a3f$export$71511d61b312f219; }, function (v) { return $128ca221f03a6a3f$export$71511d61b312f219 = v; });
var $128ca221f03a6a3f$export$71511d61b312f219;
var $128ca221f03a6a3f$export$5f0017c582d45a2d;
"use strict";
$128ca221f03a6a3f$export$71511d61b312f219 = $128ca221f03a6a3f$export$5f0017c582d45a2d = $128ca221f03a6a3f$var$_type_of;
function $128ca221f03a6a3f$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



var $27650f335af3f4c5$export$c78050b59d0802b7 = "tv2-menu";
var $27650f335af3f4c5$export$5612978d35c19998 = "tv2-menu-top-nav";
var $27650f335af3f4c5$export$850b00fcb503587c = "tv2-menu-mega-menu-toggle";
var $27650f335af3f4c5$export$e0893ac102bd73d8 = "tv2-menu--disable-mobile-top-menu-categories";
var $27650f335af3f4c5$export$3a4b1044630b7106 = "tv2-menu--minimized";



var $0e87754269846f8f$export$dde0441bd4a6ded8 = function() {
    var $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    var $topNav = document.getElementById((0, $27650f335af3f4c5$export$5612978d35c19998));
    var _$menu_getBoundingClientRect_height;
    var menuHeight = Math.ceil((_$menu_getBoundingClientRect_height = $menu === null || $menu === void 0 ? void 0 : $menu.getBoundingClientRect().height) !== null && _$menu_getBoundingClientRect_height !== void 0 ? _$menu_getBoundingClientRect_height : 0);
    var _$topNav_getBoundingClientRect_height;
    var topNavHeight = Math.ceil((_$topNav_getBoundingClientRect_height = $topNav === null || $topNav === void 0 ? void 0 : $topNav.getBoundingClientRect().height) !== null && _$topNav_getBoundingClientRect_height !== void 0 ? _$topNav_getBoundingClientRect_height : 0);
    var menuExpandThresholdPx = 30;
    var hidden = false;
    var lastScrollTop = window.scrollY;
    document.addEventListener("scroll", function() {
        var scrollTop = window.scrollY;
        var scrollDelta = Math.abs(scrollTop - lastScrollTop);
        var scrollDirection = lastScrollTop < scrollTop ? "DOWN" : "UP";
        if (scrollDirection === "DOWN") {
            if (scrollTop > menuHeight) window.requestAnimationFrame(function() {
                if (!hidden) {
                    hidden = true;
                    $menu === null || $menu === void 0 ? void 0 : $menu.classList.add((0, $27650f335af3f4c5$export$3a4b1044630b7106));
                    $menu === null || $menu === void 0 ? void 0 : $menu.style.setProperty("transform", "translateY(" + -topNavHeight + "px)");
                    var downEvent = new CustomEvent("tv2-menu:scroll-down", {});
                    document.dispatchEvent(downEvent);
                }
            });
        }
        if (scrollDirection === "UP") {
            if (scrollDelta > menuExpandThresholdPx || scrollTop < menuHeight) window.requestAnimationFrame(function() {
                if (hidden) {
                    hidden = false;
                    $menu === null || $menu === void 0 ? void 0 : $menu.classList.remove((0, $27650f335af3f4c5$export$3a4b1044630b7106));
                    $menu === null || $menu === void 0 ? void 0 : $menu.style.setProperty("transform", "translateY(0)");
                    var upEvent = new CustomEvent("tv2-menu:scroll-up", {});
                    document.dispatchEvent(upEvent);
                }
            });
        }
        lastScrollTop = scrollTop;
    });
};








var $8ffc0864d4b30959$var$track = function(event) {
    var _window_snowplowTracker, _window_snowplowTracker_coreTracker;
    (_window_snowplowTracker = window.snowplowTracker) === null || _window_snowplowTracker === void 0 ? void 0 : (_window_snowplowTracker_coreTracker = _window_snowplowTracker.coreTracker) === null || _window_snowplowTracker_coreTracker === void 0 ? void 0 : _window_snowplowTracker_coreTracker.trackUserLogin({
        userId: event.userID,
        userAction: event.eventAction
    });
};
var $8ffc0864d4b30959$export$8cda87936ff9c413 = function(action) {
    var userId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    $8ffc0864d4b30959$var$track({
        event: "loginEvent",
        eventCategory: "Login",
        eventAction: action,
        userID: userId
    });
};


var $1b3bef11b946f0c1$export$18986b1d7d261785 = function() {
    var _window_AUTH0_CONFIG = window.AUTH0_CONFIG, callbackUrl = _window_AUTH0_CONFIG.callbackUrl, domain = _window_AUTH0_CONFIG.domain, clientId = _window_AUTH0_CONFIG.clientId, userApiUrl = _window_AUTH0_CONFIG.userApiUrl;
    if (!window.auth0) return Promise.reject("auth0 script not loaded");
    return window.auth0.createAuth0Client({
        domain: domain,
        clientId: clientId,
        cacheLocation: "localstorage",
        useRefreshTokens: true,
        useRefreshTokensFallback: true,
        authorizationParams: {
            audience: "https://".concat(domain),
            redirect_uri: "".concat(callbackUrl, "?internalUrl=").concat(encodeURIComponent(location.href.toString()))
        }
    }).then(function(auth0Client) {
        var login = function() {
            var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function(reasonToLoginCategory, reasonToLoginName) {
                var opts;
                return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            opts = {
                                authorizationParams: {}
                            };
                            if (reasonToLoginCategory) opts.authorizationParams.reasonToLoginCategory = reasonToLoginCategory;
                            if (reasonToLoginName) opts.authorizationParams.reasonToLoginName = reasonToLoginName;
                            return [
                                4,
                                auth0Client.loginWithRedirect(opts)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function login(reasonToLoginCategory, reasonToLoginName) {
                return _ref.apply(this, arguments);
            };
        }();
        var logout = function() {
            var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
                var _window_TV2, user, userId;
                return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                window === null || window === void 0 ? void 0 : (_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.getLoggedInUser()
                            ];
                        case 1:
                            user = _state.sent();
                            userId = user === null || user === void 0 ? void 0 : user.id;
                            (0, $8ffc0864d4b30959$export$8cda87936ff9c413)("Logout Clicked", userId);
                            return [
                                4,
                                auth0Client.logout({
                                    logoutParams: {
                                        returnTo: "".concat(callbackUrl, "?internalUrl=").concat(encodeURIComponent(location.href.toString()), "&logout=true")
                                    }
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function logout() {
                return _ref.apply(this, arguments);
            };
        }();
        var isAuthenticated = function() {
            var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
                return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                auth0Client.isAuthenticated()
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function isAuthenticated() {
                return _ref.apply(this, arguments);
            };
        }();
        var getLoggedInUser = function() {
            var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
                var token, userResponse, e;
                return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                auth0Client.getTokenSilently({
                                    authorizationParams: {
                                        redirect_uri: location.origin
                                    }
                                })
                            ];
                        case 1:
                            token = _state.sent();
                            return [
                                4,
                                fetch(userApiUrl, {
                                    method: "get",
                                    credentials: "include",
                                    headers: new Headers({
                                        Authorization: "Bearer " + token
                                    })
                                })
                            ];
                        case 2:
                            userResponse = _state.sent();
                            return [
                                4,
                                userResponse.json()
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            e = _state.sent();
                            return [
                                2
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getLoggedInUser() {
                return _ref.apply(this, arguments);
            };
        }();
        var getToken = function() {
            var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
                return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                auth0Client.getTokenSilently({
                                    authorizationParams: {
                                        redirect_uri: location.origin
                                    }
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function getToken() {
                return _ref.apply(this, arguments);
            };
        }();
        window.TV2 = (0, $9d88e2d3b1ad3daa$export$71511d61b312f219)((0, $15954f74e53255b0$export$71511d61b312f219)({}, window.TV2), {
            login: login,
            logout: logout,
            isAuthenticated: isAuthenticated,
            getLoggedInUser: getLoggedInUser,
            getToken: getToken
        });
        return auth0Client;
    });
};




var $fdce418d1cd7b5bb$var$RECENT_LOGIN_CHECK_COOKIE = "tv2HasCheckedLogin";
var $fdce418d1cd7b5bb$export$6edebfff5396a41b = function() {
    document.cookie = "".concat($fdce418d1cd7b5bb$var$RECENT_LOGIN_CHECK_COOKIE, "=1; domain=").concat(window.location.hostname, "; path=/; max-age=", 1800);
};
var $fdce418d1cd7b5bb$export$693d6d909aa70dae = function() {
    return document.cookie.split(";").some(function(item) {
        return item.trim().startsWith("".concat($fdce418d1cd7b5bb$var$RECENT_LOGIN_CHECK_COOKIE, "="));
    });
};
var $fdce418d1cd7b5bb$export$4be65e66cfa2648a = function(name) {
    var cookies = document.cookie.split(";");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cookie = _step.value;
            var _cookie_trim_split = (0, $7ee6a96e043b6bac$export$71511d61b312f219)(cookie.trim().split("="), 2), cookieName = _cookie_trim_split[0], cookieValue = _cookie_trim_split[1];
            if (cookieName === name) return cookieValue;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};


var $35c27816a19ac90b$export$213a2dc2015f93c1 = function(auth0Client) {
    var url = new URL(location.href);
    var searchParams = new URL(location.href).searchParams;
    var isRedirectCallback = searchParams.has("code") && searchParams.has("state");
    return isRedirectCallback ? auth0Client.handleRedirectCallback().then(function() {
        url.searchParams.delete("code");
        url.searchParams.delete("state");
        history.replaceState({}, document.title, url);
        return auth0Client;
    }) : Promise.resolve(auth0Client);
};


var $86bc53116c439107$export$da4fc2bf424da4ca = function() {
    (0, $1b3bef11b946f0c1$export$18986b1d7d261785)().then((0, $35c27816a19ac90b$export$213a2dc2015f93c1)).then(function() {
        var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function(auth0Client) {
            var _window_TV2, _e, user, userId;
            return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!(0, $fdce418d1cd7b5bb$export$693d6d909aa70dae)()) return [
                            3,
                            5
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            auth0Client.getTokenSilently({
                                authorizationParams: {
                                    redirect_uri: location.origin
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        _e = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        (0, $fdce418d1cd7b5bb$export$6edebfff5396a41b)();
                        return [
                            7
                        ];
                    case 5:
                        return [
                            4,
                            window === null || window === void 0 ? void 0 : (_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.getLoggedInUser()
                        ];
                    case 6:
                        user = _state.sent();
                        userId = user === null || user === void 0 ? void 0 : user.id;
                        $86bc53116c439107$var$updateUI(user);
                        (0, $8ffc0864d4b30959$export$8cda87936ff9c413)("User Authenticated", userId);
                        // Deprecated - still in use until all uses are updated to new event
                        document.dispatchEvent(new CustomEvent("tv2-menu:auth0-ready", {
                            detail: {
                                app: false,
                                isReady: true,
                                userId: userId
                            }
                        }));
                        // New event to take over for above event
                        document.dispatchEvent(new CustomEvent("tv2-menu:auth-ready", {
                            detail: {
                                app: false,
                                isReady: true,
                                userId: userId
                            }
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function(auth0Client) {
            return _ref.apply(this, arguments);
        };
    }()).catch(function(e) {
        console.error("TV 2 Menu: Auth:", e.message);
    });
};
var $86bc53116c439107$var$updateUI = function(user) {
    var _window_TV2;
    var $authBubble = document.getElementById("tv2-menu-auth-bubble");
    var $authLabel = document.getElementById("tv2-menu-auth-label");
    var $authLabelSecondary = document.getElementById("tv2-menu-auth-label--secondary");
    var $loginButton = document.getElementById("tv2-menu-login-btn");
    var $logoutButton = document.getElementById("tv2-menu-logout-btn");
    if ($loginButton) $loginButton.onclick = /*#__PURE__*/ (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
        var _window_TV2, _window_lab_metadata, _window_lab_metadata_tags, $userProfileContextMenu;
        return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!user) return [
                        3,
                        1
                    ];
                    $userProfileContextMenu = document.getElementById("tv2-menu-auth-context-menu");
                    $userProfileContextMenu === null || $userProfileContextMenu === void 0 ? void 0 : $userProfileContextMenu.classList.toggle("tv2-menu__auth-menu--open");
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        (_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.login("Navbar", (_window_lab_metadata = window.lab_metadata) === null || _window_lab_metadata === void 0 ? void 0 : (_window_lab_metadata_tags = _window_lab_metadata.tags) === null || _window_lab_metadata_tags === void 0 ? void 0 : _window_lab_metadata_tags.sectionTag)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    if ($logoutButton) $logoutButton.onclick = (_window_TV2 = window.TV2) === null || _window_TV2 === void 0 ? void 0 : _window_TV2.logout;
    if ($authBubble && $authLabel) {
        if (user) {
            var _user_firstname, _user_firstname_split, _user_firstname1;
            $authBubble.classList.add("tv2-menu__auth-bubble--authenticated");
            var _user_firstname_;
            $authBubble.innerText = (_user_firstname_ = user === null || user === void 0 ? void 0 : (_user_firstname = user.firstname) === null || _user_firstname === void 0 ? void 0 : _user_firstname[0]) !== null && _user_firstname_ !== void 0 ? _user_firstname_ : "";
            var _user_firstname_split_;
            $authLabel.innerText = (_user_firstname_split_ = (_user_firstname_split = user === null || user === void 0 ? void 0 : (_user_firstname1 = user.firstname) === null || _user_firstname1 === void 0 ? void 0 : _user_firstname1.split(" ")) === null || _user_firstname_split === void 0 ? void 0 : _user_firstname_split[0]) !== null && _user_firstname_split_ !== void 0 ? _user_firstname_split_ : "";
            if ($authLabelSecondary) $authLabelSecondary.style.display = "none";
        } else {
            $authLabel.innerText = "Logg inn";
            $authBubble.classList.remove("tv2-menu__auth-bubble--authenticated");
        }
    }
};





var $97b4c742360fac72$export$5a86d273c3376191 = function() {
    var $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    var $menuToggle = document.getElementById((0, $27650f335af3f4c5$export$850b00fcb503587c));
    var $menuCloseButton = document.querySelector(".tv2-menu__megamenu__close-button");
    var $html = document.querySelector("html");
    var initialHtmlOverflow = $html === null || $html === void 0 ? void 0 : $html.style.overflow;
    window.TV2 = (0, $9d88e2d3b1ad3daa$export$71511d61b312f219)((0, $15954f74e53255b0$export$71511d61b312f219)({}, window.TV2), {
        toggleNavigation: function toggleNavigation() {
            $html === null || $html === void 0 ? void 0 : $html.style.setProperty("overflow", ($html === null || $html === void 0 ? void 0 : $html.style.overflow) === "hidden" ? initialHtmlOverflow !== null && initialHtmlOverflow !== void 0 ? initialHtmlOverflow : "" : "hidden");
            $menuToggle === null || $menuToggle === void 0 ? void 0 : $menuToggle.classList.toggle("tv2-menu__megamenu__toggle--open");
            $menu === null || $menu === void 0 ? void 0 : $menu.classList.toggle("tv2-menu--open");
            $menuToggle === null || $menuToggle === void 0 ? void 0 : $menuToggle.focus();
        }
    });
    if ($menuToggle) $menuToggle.onclick = window.TV2.toggleNavigation;
    if ($menuCloseButton) $menuCloseButton.onclick = function() {
        window.TV2.toggleNavigation();
    };
    document.addEventListener("keyup", function(event) {
        if (event.key === "Escape" && ($menu === null || $menu === void 0 ? void 0 : $menu.classList.contains("tv2-menu--open"))) window.TV2.toggleNavigation();
    });
};



var $ccd1fa24fcb118d8$export$d9b45b5588c57e64 = function() {
    var $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    $menu === null || $menu === void 0 ? void 0 : $menu.classList.remove((0, $27650f335af3f4c5$export$e0893ac102bd73d8));
    $ccd1fa24fcb118d8$var$updateBodyPaddingTop($menu);
};
var $ccd1fa24fcb118d8$export$c8ddb059529fd30a = function() {
    var $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    $menu === null || $menu === void 0 ? void 0 : $menu.classList.add((0, $27650f335af3f4c5$export$e0893ac102bd73d8));
    $ccd1fa24fcb118d8$var$updateBodyPaddingTop($menu);
};
var $ccd1fa24fcb118d8$var$updateBodyPaddingTop = function($menu) {
    var _$menu_getBoundingClientRect_height;
    var menuHeight = Math.round((_$menu_getBoundingClientRect_height = $menu === null || $menu === void 0 ? void 0 : $menu.getBoundingClientRect().height) !== null && _$menu_getBoundingClientRect_height !== void 0 ? _$menu_getBoundingClientRect_height : 0);
    document.body.style.paddingTop = menuHeight + "px";
};


/*
 * Some sites that include the menu may use a fouc-prevention technique that hides body content while
 * all resources are loading. In these cases the menu height will be 0 until this content is displayed.
 * We therefore add this onClientHeight function to wait for the menu to have a client height before initialising
 * scroll logic and adding top padding to the body. We limit this sequence to 10 retries (1s).
 */ var $72d78183ba861693$var$MAX_RETRIES = 10;
var $72d78183ba861693$var$TIME_BETWEEN_RETRIES_MS = 100;
var $72d78183ba861693$export$89250341c2040c2d = function($el) {
    var retries = 0;
    var retry = function() {
        var _$el_getBoundingClientRect_height;
        var menuHeight = Math.round((_$el_getBoundingClientRect_height = $el === null || $el === void 0 ? void 0 : $el.getBoundingClientRect().height) !== null && _$el_getBoundingClientRect_height !== void 0 ? _$el_getBoundingClientRect_height : 0);
        if (menuHeight === 0 && retries < $72d78183ba861693$var$MAX_RETRIES) {
            retries++;
            return new Promise(function(resolve) {
                return setTimeout(resolve, $72d78183ba861693$var$TIME_BETWEEN_RETRIES_MS);
            }).then(retry);
        }
        return Promise.resolve(menuHeight);
    };
    return retry();
};


/*
 * Check if the user is authenticated with Auth0
 */ var $ac9a226636de795d$var$MAX_RETRIES = 10;
var $ac9a226636de795d$var$TIME_BETWEEN_RETRIES_MS = 100;
var $ac9a226636de795d$export$eb86a8b8512b1ef2 = function() {
    var retries = 0;
    var retry = function() {
        return typeof window.auth0 !== "object" && retries < $ac9a226636de795d$var$MAX_RETRIES ? new Promise(function(resolve) {
            return setTimeout(resolve, $ac9a226636de795d$var$TIME_BETWEEN_RETRIES_MS);
        }).then(function() {
            retries++;
            return retry();
        }) : Promise.resolve(true);
    };
    return retry();
};






var $313a413ce328ff04$var$localstorage = (window === null || window === void 0 ? void 0 : window.localStorage) || null;
var $313a413ce328ff04$export$93d719890ad66653 = function(key) {
    var itemString = $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.getItem(key);
    if (!itemString) return null;
    var item = JSON.parse(itemString);
    var now = new Date();
    if (now.getTime() > item.expiry) {
        $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.removeItem(key);
        return null;
    }
    return item.value;
};
var $313a413ce328ff04$export$5aa524d86254b4f = function(key, value) {
    var ttl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var now = new Date();
    var item = {
        value: value,
        expiry: now.getTime() + ttl * 3600000
    };
    $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.setItem(key, JSON.stringify(item));
};
var $313a413ce328ff04$export$baf306891f1b93bd = function(key) {
    $313a413ce328ff04$var$localstorage === null || $313a413ce328ff04$var$localstorage === void 0 ? void 0 : $313a413ce328ff04$var$localstorage.removeItem(key);
};


var $8935bf2b06df93ed$export$4f3f2c03d33caf29 = function(token) {
    var existingLocalStorageToken = (0, $313a413ce328ff04$export$93d719890ad66653)("appAuthToken");
    if (token === "null" || token === "") {
        (0, $313a413ce328ff04$export$baf306891f1b93bd)("appAuthToken");
        (0, $313a413ce328ff04$export$baf306891f1b93bd)("appUser");
    } else if (token && !existingLocalStorageToken || token !== existingLocalStorageToken) (0, $313a413ce328ff04$export$5aa524d86254b4f)("appAuthToken", token);
};
var $8935bf2b06df93ed$export$407a6a3870454386 = function() {
    var userApiUrl = window.AUTH0_CONFIG.userApiUrl;
    var login = function() {
        var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function(reasonToLoginCategory, reasonToLoginName) {
            var _window_webkit, _window_webkit_messageHandlers, _window_TV2JSBridge, data;
            return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                data = {
                    reasonToLoginCategory: reasonToLoginCategory,
                    reasonToLoginName: reasonToLoginName
                };
                if (window === null || window === void 0 ? void 0 : (_window_webkit = window.webkit) === null || _window_webkit === void 0 ? void 0 : (_window_webkit_messageHandlers = _window_webkit.messageHandlers) === null || _window_webkit_messageHandlers === void 0 ? void 0 : _window_webkit_messageHandlers.onLoginEvent) window.webkit.messageHandlers.onLoginEvent.postMessage(JSON.stringify(data));
                if (typeof window.TV2JSBridge !== "undefined" && typeof (window === null || window === void 0 ? void 0 : (_window_TV2JSBridge = window.TV2JSBridge) === null || _window_TV2JSBridge === void 0 ? void 0 : _window_TV2JSBridge.onLoginEvent) === "function") window.TV2JSBridge.onLoginEvent(JSON.stringify(data));
                return [
                    2
                ];
            });
        });
        return function login(reasonToLoginCategory, reasonToLoginName) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLoggedInUser = function() {
        var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
            var token, appUser, userResponse, user, e;
            return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getToken()
                        ];
                    case 1:
                        token = _state.sent();
                        appUser = (0, $313a413ce328ff04$export$93d719890ad66653)("appUser");
                        if (appUser) return [
                            2,
                            appUser
                        ];
                        return [
                            4,
                            fetch(userApiUrl, {
                                method: "get",
                                credentials: "include",
                                headers: new Headers({
                                    Authorization: "Bearer " + token
                                })
                            })
                        ];
                    case 2:
                        userResponse = _state.sent();
                        return [
                            4,
                            userResponse.json()
                        ];
                    case 3:
                        user = _state.sent();
                        (0, $313a413ce328ff04$export$5aa524d86254b4f)("appUser", user, 6);
                        return [
                            2,
                            user
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getLoggedInUser() {
            return _ref.apply(this, arguments);
        };
    }();
    // TODO: Remove when all apps are exposing native getToken()
    var setToken = function setToken(token) {
        console.warn("DEPRECATION WARNING | TV 2 Menu: SetToken: ", token === null || token === void 0 ? void 0 : token.length);
        $8935bf2b06df93ed$export$4f3f2c03d33caf29(token);
        document.dispatchEvent(new CustomEvent("tv2-menu:set-token", {
            detail: {
                isSet: true,
                app: true,
                deprecated: true
            }
        }));
        // IOS webview demands that a string is returned
        return "TOKEN_SET";
    };
    var getToken = function() {
        var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
            var _window_webkit, _window_webkit_messageHandlers, _window_TV2JSBridge, _getLocalStorageItem;
            return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(window === null || window === void 0 ? void 0 : (_window_webkit = window.webkit) === null || _window_webkit === void 0 ? void 0 : (_window_webkit_messageHandlers = _window_webkit.messageHandlers) === null || _window_webkit_messageHandlers === void 0 ? void 0 : _window_webkit_messageHandlers.getToken)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            window.webkit.messageHandlers.getToken.postMessage("getToken")
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        if (!(typeof window.TV2JSBridge !== "undefined" && typeof ((_window_TV2JSBridge = window.TV2JSBridge) === null || _window_TV2JSBridge === void 0 ? void 0 : _window_TV2JSBridge.getToken) === "function")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            window.TV2JSBridge.getToken()
                        ];
                    case 3:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 4:
                        // TODO: Remove when all apps are exposing native getToken()
                        return [
                            2,
                            (_getLocalStorageItem = (0, $313a413ce328ff04$export$93d719890ad66653)("appAuthToken")) !== null && _getLocalStorageItem !== void 0 ? _getLocalStorageItem : ""
                        ];
                }
            });
        });
        return function getToken() {
            return _ref.apply(this, arguments);
        };
    }();
    var isAuthenticated = function() {
        var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
            var token;
            return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getToken()
                        ];
                    case 1:
                        token = _state.sent();
                        return [
                            2,
                            !!(token && token !== "" && (token === null || token === void 0 ? void 0 : token.length) > 100)
                        ];
                }
            });
        });
        return function isAuthenticated() {
            return _ref.apply(this, arguments);
        };
    }();
    window.TV2 = (0, $9d88e2d3b1ad3daa$export$71511d61b312f219)((0, $15954f74e53255b0$export$71511d61b312f219)({}, window.TV2), {
        login: login,
        getLoggedInUser: getLoggedInUser,
        getToken: getToken,
        setToken: setToken,
        isAuthenticated: isAuthenticated
    });
    var init = function() {
        var _ref = (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
            var user, userId;
            return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getLoggedInUser()
                        ];
                    case 1:
                        user = _state.sent();
                        userId = user === null || user === void 0 ? void 0 : user.id;
                        // Deprecated - still in use until all uses are updated to new event
                        document.dispatchEvent(new CustomEvent("tv2-menu:auth0-ready", {
                            detail: {
                                app: true,
                                isReady: true,
                                userId: userId
                            }
                        }));
                        // New event to take over for above event
                        document.dispatchEvent(new CustomEvent("tv2-menu:auth-ready", {
                            detail: {
                                app: true,
                                isReady: true,
                                userId: userId
                            }
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function init() {
            return _ref.apply(this, arguments);
        };
    }();
    init();
};


var $410d84ca1ebf0031$var$init = function() {
    var _window_webkit;
    /*
   * Menu is initially positioned as a block element to avoid CLS on page load.
   * When the page is loaded, we position the menu as a fixed and also add
   * top padding to the body equal to the menu height.
   */ var $menu = document.getElementById((0, $27650f335af3f4c5$export$c78050b59d0802b7));
    var $topNav = document.getElementById((0, $27650f335af3f4c5$export$5612978d35c19998));
    var _$topNav_getBoundingClientRect_height;
    var topNavHeight = Math.ceil((_$topNav_getBoundingClientRect_height = $topNav === null || $topNav === void 0 ? void 0 : $topNav.getBoundingClientRect().height) !== null && _$topNav_getBoundingClientRect_height !== void 0 ? _$topNav_getBoundingClientRect_height : 0);
    // Note: Since the sportsapp is the only app that has shared login, we differenciate beetween tv2no and sportsapp
    var useJSBridgeLogin = window.MENU_CONFIG.useJSBridgeLogin;
    var hasWebviewBrigde = (window === null || window === void 0 ? void 0 : window.TV2JSBridge) || (window === null || window === void 0 ? void 0 : (_window_webkit = window.webkit) === null || _window_webkit === void 0 ? void 0 : _window_webkit.messageHandlers);
    (0, $72d78183ba861693$export$89250341c2040c2d)($menu).then(function(menuHeight) {
        $menu === null || $menu === void 0 ? void 0 : $menu.classList.add("tv2-menu--fixed");
        document.body.style.paddingTop = menuHeight + "px";
        if (document.documentElement.dataset.menuHideOnScroll !== "false") (0, $0e87754269846f8f$export$dde0441bd4a6ded8)();
        (0, $97b4c742360fac72$export$5a86d273c3376191)();
        if (useJSBridgeLogin && hasWebviewBrigde) (0, $8935bf2b06df93ed$export$407a6a3870454386)();
        else (0, $86bc53116c439107$export$da4fc2bf424da4ca)();
        /*
     * Client side api for menu customizations (e.g. show/hide categories on mobile) will be handled
     * through custom events with the tv2-menu namespace/prefix.
     */ document.addEventListener("tv2-menu:show-mobile-categories", (0, $ccd1fa24fcb118d8$export$d9b45b5588c57e64));
        document.addEventListener("tv2-menu:hide-mobile-categories", (0, $ccd1fa24fcb118d8$export$c8ddb059529fd30a));
        /*
     * Let the world know that the menu is ready.
     */ var eventDetail = {
            $el: $menu,
            menuHeight: menuHeight,
            topNavHeight: topNavHeight,
            heightDiff: menuHeight - topNavHeight
        };
        var readyEvent = new CustomEvent("tv2-menu:ready", {
            detail: eventDetail
        });
        document.dispatchEvent(readyEvent);
        // Register the menuReady as a global variable
        window.TV2 = window.TV2 || {};
        window.TV2.MenuReady = function() {
            var dispatchEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (dispatchEvent) return document.dispatchEvent(readyEvent);
            return eventDetail;
        };
    });
    window.TV2 = window.TV2 || {};
    window.TV2.isAuthReady = /*#__PURE__*/ (0, $3ba46ddf021b8b99$export$71511d61b312f219)(function() {
        return (0, $a03c591f49ea2337$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // When in apps
                    if (hasWebviewBrigde && useJSBridgeLogin) return [
                        2,
                        true
                    ];
                    return [
                        4,
                        (0, $ac9a226636de795d$export$eb86a8b8512b1ef2)()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
};
if (document.readyState === "complete") $410d84ca1ebf0031$var$init();
else document.addEventListener("DOMContentLoaded", $410d84ca1ebf0031$var$init);

var $3ba46ddf021b8b99$export$71511d61b312f219;
var $3ba46ddf021b8b99$export$7c398597f8905a1;
"use strict";
function $3ba46ddf021b8b99$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
$3ba46ddf021b8b99$export$71511d61b312f219 = $3ba46ddf021b8b99$export$7c398597f8905a1 = $3ba46ddf021b8b99$var$_async_to_generator;
function $3ba46ddf021b8b99$var$_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $3ba46ddf021b8b99$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $3ba46ddf021b8b99$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var $a03c591f49ea2337$export$71511d61b312f219;
var $a03c591f49ea2337$export$cf587fbfbb3bc6b8;
"use strict";

$a03c591f49ea2337$export$71511d61b312f219 = $a03c591f49ea2337$export$cf587fbfbb3bc6b8 = (parcelRequire("jqhiM")).__generator;

var $15954f74e53255b0$export$71511d61b312f219;
var $15954f74e53255b0$export$581ff339ea0ba762;
"use strict";
var $da4b0ec610ae780b$export$71511d61b312f219;
var $da4b0ec610ae780b$export$1e71eb4bef00f6b0;
"use strict";
$da4b0ec610ae780b$export$71511d61b312f219 = $da4b0ec610ae780b$export$1e71eb4bef00f6b0 = $da4b0ec610ae780b$var$_define_property;
function $da4b0ec610ae780b$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


$15954f74e53255b0$export$71511d61b312f219 = $15954f74e53255b0$export$581ff339ea0ba762 = $15954f74e53255b0$var$_object_spread;
function $15954f74e53255b0$var$_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $da4b0ec610ae780b$export$71511d61b312f219(target, key, source[key]);
        });
    }
    return target;
}

var $9d88e2d3b1ad3daa$export$71511d61b312f219;
var $9d88e2d3b1ad3daa$export$4fa2f4023c9cbda5;
"use strict";
function $9d88e2d3b1ad3daa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
$9d88e2d3b1ad3daa$export$71511d61b312f219 = $9d88e2d3b1ad3daa$export$4fa2f4023c9cbda5 = $9d88e2d3b1ad3daa$var$_object_spread_props;
function $9d88e2d3b1ad3daa$var$_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $9d88e2d3b1ad3daa$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

var $7ee6a96e043b6bac$export$71511d61b312f219;
var $7ee6a96e043b6bac$export$fdf2a89c76341bbf;
"use strict";
var $48561866f52c4120$export$71511d61b312f219;
var $48561866f52c4120$export$e6256bf45c68d561;
"use strict";
$48561866f52c4120$export$71511d61b312f219 = $48561866f52c4120$export$e6256bf45c68d561 = $48561866f52c4120$var$_array_with_holes;
function $48561866f52c4120$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}


var $7e08d10ed68c3325$export$71511d61b312f219;
var $7e08d10ed68c3325$export$2fd15edff6687200;
"use strict";
$7e08d10ed68c3325$export$71511d61b312f219 = $7e08d10ed68c3325$export$2fd15edff6687200 = $7e08d10ed68c3325$var$_iterable_to_array_limit;
function $7e08d10ed68c3325$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


var $406138d6874f447b$export$71511d61b312f219;
var $406138d6874f447b$export$60dbc22abd7da546;
"use strict";
$406138d6874f447b$export$71511d61b312f219 = $406138d6874f447b$export$60dbc22abd7da546 = $406138d6874f447b$var$_non_iterable_rest;
function $406138d6874f447b$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


var $97089b6ddee25ada$export$71511d61b312f219;
var $97089b6ddee25ada$export$a5be06335b3a083c;
"use strict";
var $c33028f9e7769bd1$export$71511d61b312f219;
var $c33028f9e7769bd1$export$79e617b1955a2616;
"use strict";
$c33028f9e7769bd1$export$71511d61b312f219 = $c33028f9e7769bd1$export$79e617b1955a2616 = $c33028f9e7769bd1$var$_array_like_to_array;
function $c33028f9e7769bd1$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


$97089b6ddee25ada$export$71511d61b312f219 = $97089b6ddee25ada$export$a5be06335b3a083c = $97089b6ddee25ada$var$_unsupported_iterable_to_array;
function $97089b6ddee25ada$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c33028f9e7769bd1$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c33028f9e7769bd1$export$71511d61b312f219(o, minLen);
}


$7ee6a96e043b6bac$export$71511d61b312f219 = $7ee6a96e043b6bac$export$fdf2a89c76341bbf = $7ee6a96e043b6bac$var$_sliced_to_array;
function $7ee6a96e043b6bac$var$_sliced_to_array(arr, i) {
    return $48561866f52c4120$export$71511d61b312f219(arr) || $7e08d10ed68c3325$export$71511d61b312f219(arr, i) || $97089b6ddee25ada$export$71511d61b312f219(arr, i) || $406138d6874f447b$export$71511d61b312f219();
}


//# sourceMappingURL=menu.js.map
